import Axios from "axios";
import React from "react";
import { sortCaret } from "../../../_metronic/_helpers";

//const url_users = "http://localhost:5000/gt-out/us-central1/api/v2/users";
const url_users = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v2/users";

export const columns = [
  {
    dataField: "name",
    text: "Name",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "genre",
    text: "Genre",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "bank_routing",
    text: "Bank Routing",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "bank_account",
    text: "Bank Account",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "phone",
    text: "Phone",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "docheck",
    text: "Status",
    sort: true,
sortCaret: sortCaret,
    formatter: StatusColumnFormatter,
    formatExtraData: {
      openEditCustomerDialog: () => {},
      openDeleteCustomerDialog: () => {},
    },
  },
];
function StatusColumnFormatter(cellContent, row) {
  return <span className={!row?.docheck ? "text-danger" : "text-success"}>{row?.docheck ? "verified" : "not verified"}</span>;
}

export function getClients(setClients) {
  Axios.get(`${url_users}/find`)
    .then((res) => {
      const users = res.data.payload;
      console.log({users});
      setClients(users);
    })
 .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
          console.log(`request cancelled:${thrown.message}`)
      } else {
          console.log('another error happened')
      }
  })}
export function getClient(uid = "") {
  return Axios.get(`${url_users}/find/${uid}`);
}
export function updateClient(location) {
  if (location.uid) {
    return Axios.put(`${url_users}/update/${location.uid}`, location);
  } else {
    return Axios.post(`${url_users}/create`, location);
  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url_users}/delete/${uid}`);
}
export function getClientV1(uid = ""){
  return Axios.get(process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + `/v1/users/${uid}`)
}